module.exports = __webpack_public_path__ + "static/media/html.352a1680.svg";